
import React from "react";
import { CheckCircle } from "lucide-react";

// WhatsApp Leads Data
const whatsappLeadsData = [
  {
    heading: "Bring New Customers to Your Beauty & Cosmetics Brand",
    points: [
      "Run click-to-WhatsApp ads to catch customer interest fast.",
      "Add a WhatsApp widget to your site for instant chats.",
      "Use QR codes on ads and packaging to get more sign-ups.",
      "Share WhatsApp links on social media to grow your reach.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Beauty_Cosmetics/Beauty_and_Cosmetics_2.png",
  },
  {
    heading: "Turn Shoppers into Buyers with WhatsApp Magic",
    points: [
      "Send a friendly welcome series to learn what customers want.",
      "Highlight top products with WhatsApp catalog messages.",
      "Take payments right in WhatsApp with easy checkout links.",
      "Bring back lost sales with automated cart recovery messages.",
    ],
    // buttonText: "Get Start ",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Beauty_Cosmetics/Beauty_and_Cosmetics_3.png",
  },
  {
    heading: "Keep Customers Engaged and Boost Sales",
    points: [
      "Announce new launches and offers with WhatsApp broadcasts.",
      "Share customer reviews and photos to build trust.",
      "Run fun contests and quizzes with interactive messages.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Beauty_Cosmetics/Beauty_and_Cosmetics_4.png",
  },
  {
    heading: "Create a Personal Shopping Journey for Loyalty",
    points: [
      "Offer helpful support before, during, and after purchases.",
      "Send order updates and shipping alerts automatically.",
      "Cut down returns with clear delivery notifications.",
      "Ask for reviews and feedback right on WhatsApp.",
      "Share beauty tips, lookbooks, and how-to videos.",
    ],
    // buttonText: "Get Start ",
    buttonText: "Meta Policy for Beauty and Cosmetics",
    buttonLink:"https://transparency.meta.com/en-gb/policies/ad-standards/content-specific-restrictions/cosmetic-procedures-and-wellness/",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Beauty_Cosmetics/Beauty_and_Cosmetics_5.png",
  },
  {
    heading: "Why WhatsApp Wins for Beauty & Cosmetics",
    points: [
      "Connect with a huge global audience instantly.",
      "Get messages read in just 3 minutes on average.",
      "Enjoy a 98% open rate on broadcasts and updates.",
      "See 45-57% click-through rates on your messages.",
      "Boost engagement by 53% across the shopping journey.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Beauty_Cosmetics/Beauty_and_Cosmetics_6.png",
  },
];

const Beautycycle = () => {
  return (
    <>
      <div className="bg-gradient-to-r from-pink-200 via-pink-300 to-pink-400 py-12 px-6 text-center">
        <h1 className="text-4xl font-bold text-gray-900">How WhatsApp Grows Your Beauty & Cosmetics Business</h1>
        <div className="w-16 h-1 bg-gray-600 my-4 mx-auto rounded-full"></div>
        <p className="text-xl text-gray-800 max-w-3xl mx-auto">With the beauty industry booming at a 4.75% growth rate worldwide, top brands use WhatsApp Business API to stand out, connect with shoppers, and drive sales in a crowded market.</p>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-20">
        {whatsappLeadsData.map((item, index) => (
          <div key={index} className={`flex flex-col lg:flex-row items-center gap-16 my-20 ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
            <div className="w-full lg:w-1/2">
              <img src={item.image} alt={item.heading} className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
            </div>
            <div className="w-full lg:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">{item.heading}</h2>
              <ul className="space-y-4 text-gray-700">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
              {item.buttonText && (
               <a
               href={item.buttonLink}
               className="mt-6 inline-block bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors"
             >
               {item.buttonText}
             </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Beautycycle;